export enum AuthorityNCM {
  REGISTER_NCM_REPORT_OF_NCMS = '1.16.5',
  REGISTER_NCM_EDIT = '1.16.4',
  REGISTER_NCM_DELETE = '1.16.3',
  REGISTER_NCM_ADD = '1.16.2',
  REGISTER_NCM_VIEW = '1.16.1',
  REGISTER_NCM_REGISTRATION = '1.16',
}
